const defaultTheme = require("tailwindcss/defaultTheme");
const { tailwindExtensions, screens } =
  require("./styles/tailwindExtensions").default;

const theme = {
  ...tailwindExtensions,
  screens,
  tailwindExtensions,
};

export { screens };
const { colors: extensionColors } = tailwindExtensions;
const colors = { ...extensionColors, ...defaultTheme.colors };

export const lightThemeName = "light";
export const darkThemeName = "dark";
export const lightBackgroundColor = "#FAFAFA";
export const darkBackgroundColor = "#020202";

export { colors };

export const aux = {
  headerHeight: 64,
  mobile: {
    navbarHeight: 75,
    criticalBannerHeight: 56,
  },
  desktop: {
    navbarWidthSm: 48,
    navbarWidthLg: 240,
  },
};

export default theme;
